import {
  TablePagination,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Avatar,
  Rating,
  FormControlLabel,
  FormGroup,
  Box,
  Tooltip,
  Button,
  Collapse,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Chip,
} from "@mui/material";
import React, { useState } from "react";
import appcolors from "../../constants/Colors";
import {
  calculatePackageDuration,
  calculateRemainingDays,
  formattedDate,
  formattedTime,
  getStatusBackgroundColor,
} from "../../utils";
import IOSSwitch from "../IsoSwitch";
import { allIcons, allImages } from "../../assets";
import moment from "moment";
import StraightIcon from "@mui/icons-material/Straight";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SupplierRoutes } from "../../routes";
import BarChart from "../Dashboard/BarChart";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GlobalButton from "../CustomButton";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useSelector } from "react-redux";
import { t } from "i18next";

const tableStyle = {
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: appcolors.primary,
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: appcolors.white,
      fontSize: "0.8rem",
    },

  "& .MuiTableCell-root .MuiTypography-body1 ": {
    fontSize: "0.875rem",
  },
  "&.MuiTableContainer-root": {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: appcolors.primary,
      // borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: appcolors.secondary,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: appcolors.lightGrey,
    },
  },
};

export default function DynamicTable({
  tableWidth,
  minWidth,
  tableHeader,
  tableData,
  displayRows,
  showDelete,
  showEdit,
  showCalender,
  showLogin,
  showDetail,
  showReviewText,
  handleNavigate,
  showPagination = true,
  showDownloadBtn,
  handleDownloadInvoice,
  handleChangeStatus,
  showMapIcon,
  showBranchChart,
  showActions,
  handleNavigateToSaleDetail,
  handleEdit,
  showStatusMenu,
  showStudentDetails,
  handleNavigateToStudentDetails,
  showView,
  handleClickOnstatusMenu,
  showPrintButton,
  handleViewDetail,
  showGenerateReportButton,
  handleGenerateReport,
  handleDelete,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedChartRow, setExpandedChartRow] = useState(null);
  const [rowData, setRowData] = useState(null);

  const [meunAnchorEl, setMenuAnchorEl] = useState(null);
  const openAddEditMenu = Boolean(meunAnchorEl);

  const [statusMenuAnchorE1, setStatusAnchorE1] = useState(null);
  const openStatusMenu = Boolean(statusMenuAnchorE1);

  const userData = useSelector((state) => state.userData.user);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const handleClickStatusMenu = (event) => {
    setStatusAnchorE1(event);
  };

  const handleCloseStatusMenu = () => {
    setStatusAnchorE1(null);
  };

  const handleClickAddEditMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
    console.log(event, "hellllllllllllllll");
  };

  const handleCloseAddEditMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAccordionToggle = (rowIndex) => {
    setExpandedRow(expandedRow === rowIndex ? null : rowIndex);
  };

  const handleOpenChartRow = (rowIndex) => {
    setExpandedChartRow(expandedChartRow === rowIndex ? null : rowIndex);
  };

  const IconButton = ({ children, handleClick }) => {
    return (
      <Box
        width={22}
        height={22}
        sx={{ cursor: "pointer" }}
        onClick={handleClick}
      >
        {children}
      </Box>
    );
  };

  const renderReqStatusButton = (row) => {
    const btnStyle = {
      height: 36,
      width: 120,
      fontSize: "0.85rem",
      borderRadius: "5px",
    };
    if (row.status === "New Request") {
      return (
        <GlobalButton btnText={"newRequest"} styleProps={{ ...btnStyle }} />
      );
    }
    if (row.status === "Accepted") {
      return (
        <GlobalButton
          btnText={"accepted"}
          styleProps={{
            ...btnStyle,
            backgroundColor: "custom.softGreen",
            borderColor: "custom.softGreen",
          }}
          hoverProperties={{
            borderColor: "custom.softGreen",
            backgroundColor: "custom.softGreen",
          }}
        />
      );
    }
    if (row.status === "Rejected") {
      return (
        <GlobalButton
          btnText={"rejected"}
          styleProps={{
            ...btnStyle,
            backgroundColor: "custom.radicalRed",
            borderColor: "custom.radicalRed",
          }}
          hoverProperties={{
            backgroundColor: "custom.radicalRed",
            borderColor: "custom.radicalRed",
          }}
        />
      );
    }
  };

  return (
    <TableContainer sx={tableStyle}>
      <Table
        sx={{
          width: tableWidth ? tableWidth : "100%",
          minWidth: minWidth ? minWidth : "900px",
        }}
      >
        <TableHead>
          <TableRow>
            {tableHeader?.map((header) => (
              <TableCell key={header}>{t(header)}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? tableData?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
            : tableData
          )?.map((row, index) => {
            let time = calculatePackageDuration(row.startDate, row.endDate);
            let packageExpireDays = calculateRemainingDays(row.endDate);

            return (
              <React.Fragment key={index}>
                <TableRow>
                  {displayRows.map((val) => {
                    return (
                      <React.Fragment key={val}>
                        {val === "idAscending" ? (
                          <TableCell>{index + 1}</TableCell>
                        ) : val === "refId" ? (
                          <TableCell>#{row.refID}</TableCell>
                        ) : val === "refrence_id" ? (
                          <TableCell>#{row.refrendId}</TableCell>
                        ) : val === "date_time" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {formattedDate(row.createdAt, false)}
                            </Typography>
                            <Typography variant="body2">
                              {formattedTime(row.createdAt, true)}
                            </Typography>
                          </TableCell>
                        ) : val === "valid_at" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {formattedDate(row.durationValid, false)}
                            </Typography>
                            <Typography variant="body2">
                              {formattedTime(row.durationValid, true)}
                            </Typography>
                          </TableCell>
                        ) : val === "price_usd" ? (
                          <TableCell>{`${row.price} USD`}</TableCell>
                        ) : val === "person_detail" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={allImages.image}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.email}
                                </Typography>

                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.contact}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "client_details" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.email}/{row.contact}
                                </Typography>

                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.location}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "client_service" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {` ${row.category} Categories`}
                            </Typography>
                            <Typography variant="body2">
                              {`${row.service} ${t("services")}`}
                            </Typography>
                          </TableCell>
                        ) : val === "client_reviews" ? (
                          <TableCell>
                            <Stack>
                              <Stack
                                gap={1}
                                direction={"row"}
                                alignItems={"center"}
                              >
                                <Rating
                                  value={4}
                                  precision={0.5}
                                  max={1}
                                  readOnly
                                  size="small"
                                  color="#FF9A01"
                                />
                                <Typography variant="body2" color={"#747677"}>
                                  {`4.8 (21 Review)`}
                                </Typography>
                              </Stack>
                              {showReviewText && (
                                <Typography
                                  variant="body2"
                                  color={appcolors.primary}
                                  fontSize={"0.75rem"}
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => handleNavigate(row, index)}
                                >
                                  {t("viewAll")}
                                </Typography>
                              )}
                            </Stack>
                          </TableCell>
                        ) : val === "status" ? (
                          <TableCell>
                            <FormGroup
                              sx={{
                                "&.MuiFormGroup-root .MuiFormControlLabel-root":
                                  {
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                  },
                                "&.MuiFormGroup-root .MuiFormControlLabel-root .MuiFormControlLabel-label ":
                                  {
                                    fontSize: "0.75rem",
                                  },
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <IOSSwitch
                                    defaultChecked
                                    checked={row.status}
                                    onChange={() =>
                                      handleChangeStatus(row, index)
                                    }
                                  />
                                }
                                label={row.status ? t("open") : t("close")}
                              />
                            </FormGroup>
                          </TableCell>
                        ) : val === "user_details_review" ? (
                          <TableCell>
                            <Stack>
                              <Stack
                                direction={"row"}
                                justifyContent={"space-between"}
                              >
                                <Typography
                                  variant="h3"
                                  fontSize={"1rem"}
                                  fontWeight={600}
                                >
                                  {row.username}
                                </Typography>
                                <Rating
                                  value={row.rating}
                                  precision={0.5}
                                  readOnly
                                  size="small"
                                  color="#7922D8"
                                />
                              </Stack>
                              <Typography variant="body2">
                                {row.comment}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "reviewed_product_detail" ? (
                          <TableCell>
                            <Stack>
                              <Stack
                                direction={"row"}
                                alignItems={"center"}
                                gap={1}
                              >
                                <Avatar
                                  src={row.productImage}
                                  sx={{
                                    height: 55,
                                    width: 55,
                                    borderRadius: "6px",
                                  }}
                                />
                                <Typography variant="body1">
                                  {row.productName}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "category_name" ? (
                          <TableCell>
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                alt={`${row.name}-image`}
                                sx={{ borderRadius: 2 }}
                              />
                              <Stack gap={1}>
                                <Typography
                                  variant="h3"
                                  fontSize={"0.875rem"}
                                  fontWeight={500}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.description.length > 150
                                    ? `${row.description.slice(0, 150)}....`
                                    : row.description}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "destination_area" ? (
                          <TableCell>{row?.destinationArea}</TableCell>
                        ) : val === "show_Order_Status" ? (
                          <TableCell>
                            <Stack direction={"row"}>
                              <Stack
                                padding={1}
                                bgcolor={getStatusBackgroundColor(row?.status)}
                                borderRadius={10}
                                width={100}
                              >
                                <Typography
                                  variant="body1"
                                  fontSize={"0.875rem"}
                                  fontWeight={500}
                                  textAlign={"center"}
                                  color={"secondary.light"}
                                >
                                  {row?.status}
                                </Typography>
                              </Stack>
                              <Stack
                                onClick={() => handleNavigateToSaleDetail(row)}
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                ml={1}
                                sx={{ cursor: "pointer" }}
                              >
                                <img src={allIcons.rightArrowIcon} width={20} />
                                <Typography
                                  variant="body1"
                                  fontWeight={500}
                                  textAlign={"center"}
                                  color={"secondary.dark"}
                                >
                                  {t("details")}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "selling_price" ? (
                          <TableCell>{row?.sellingPrice} USD</TableCell>
                        ) : val === "category_description" ? (
                          <TableCell>
                            <Typography
                              variant="body1"
                              fontSize={"0.75rem"}
                              color={appcolors.gunmetal}
                              textTransform={"capitalize"}
                            >
                              {row.description.length > 150
                                ? `${row.description.slice(0, 150)}....`
                                : row.description}
                            </Typography>
                          </TableCell>
                        ) : val === "service_duration" ? (
                          <TableCell>{`${row.duration} min`}</TableCell>
                        ) : val === "service_cost" ? (
                          <TableCell>{`${row.cost} USD`}</TableCell>
                        ) : val === "notification_title" ? (
                          <TableCell>
                            <Typography variant="body2" color={"#161C2D"}>
                              {`${t("title")} : ${row.title}`}
                            </Typography>
                          </TableCell>
                        ) : val === "notification_timer" ? (
                          <TableCell>
                            <Typography variant="body2">
                              {formattedDate(row.timer, false)}
                            </Typography>
                            <Typography
                              variant="body2"
                              textTransform={"capitalize"}
                            >
                              {moment(row.timer).format("dddd h:m a")}
                            </Typography>
                          </TableCell>
                        ) : val === "notification_send" ? (
                          <TableCell>
                            <Box
                              onClick={() => handleNavigate(row, index)}
                              sx={{ cursor: "pointer" }}
                            >
                              <IconButton>
                                <img
                                  src={allIcons.rightArrowIcon}
                                  alt="login-icon"
                                  width={"100%"}
                                  // height={"100%"}
                                />
                              </IconButton>
                              <Typography
                                variant="body2"
                                fontSize={"0.75rem"}
                                color={
                                  row.status === "Timer" ? "#FF9A01" : "#218E06"
                                }
                              >
                                {row.status === "Timer"
                                  ? t("timer")
                                  : t("send")}
                              </Typography>
                            </Box>
                          </TableCell>
                        ) : val === "subscriber_plan" ? (
                          <TableCell>
                            <Stack>
                              <Typography variant="body2">
                                <strong>{t("freePlan")}</strong> :{" "}
                                {row.subscribedPlan.free}
                              </Typography>
                              <Typography variant="body2">
                                <strong>{t("starterPlan")}</strong> :{" "}
                                {row.subscribedPlan.starter}
                              </Typography>
                              <Typography variant="body2">
                                <strong>{t("growthPlan")}</strong> :{" "}
                                {row.subscribedPlan.growth}
                              </Typography>
                            </Stack>
                          </TableCell>
                        ) : val === "earning_total" ? (
                          <TableCell>{`${row.profit} USD`}</TableCell>
                        ) : val === "invoice_id" ? (
                          <TableCell>{`#${row.id}`}</TableCell>
                        ) : val === "package_duration" ? (
                          <TableCell>{`${formattedDate(
                            row.startDate,
                            false
                          )} ${t("to")} ${formattedDate(
                            row.endDate,
                            false
                          )} `}</TableCell>
                        ) : val === "package_left_days" ? (
                          <TableCell>
                            {row.status === "expired"
                              ? `0 ${t("days")}`
                              : calculateRemainingDays(row.endDate) +
                                " " +
                                t("days")}
                          </TableCell>
                        ) : val === "time_duration" ? (
                          <TableCell>{t("month")}</TableCell>
                        ) : val === "invoice_shop_name" ? (
                          <TableCell>
                            <Typography
                              variant="h3"
                              fontSize={"0.875rem"}
                              fontWeight={500}
                            >
                              {row.name}
                            </Typography>
                          </TableCell>
                        ) : val === "package_name" ? (
                          <TableCell>{`${row.package} ${t(
                            "package"
                          )}`}</TableCell>
                        ) : val === "active_package_name" ? (
                          <TableCell
                            style={{ textTransform: "capitalize" }}
                          >{`${row.subscriptionId.name[currentLanguage]} ${t(
                            "plan"
                          )}`}</TableCell>
                        ) : val === "user_name_supplier" ? (
                          <TableCell style={{ textTransform: "capitalize" }}>
                            {row?.username || "_"}
                          </TableCell>
                        ) : val === "subscription_status" ? (
                          <TableCell>
                            <Chip
                              sx={{
                                width: "60px",
                                borderRadius: "6px",
                                backgroundColor:
                                  row.status === "active"
                                    ? "#00c100"
                                    : "#ff0000e8",
                                "& .MuiChip-label": {
                                  padding: 0,
                                  color: "#ffffff",
                                },
                              }}
                              label={
                                row.status === "active"
                                  ? t("active")
                                  : t("expired")
                              }
                            />
                          </TableCell>
                        ) : val === "invoice_status" ? (
                          <TableCell>
                            <Typography
                              variant="h3"
                              fontSize={"0.875rem"}
                              fontWeight={500}
                              color={
                                row.status == "Done"
                                  ? "#19BB34"
                                  : row.status == "Pending"
                                  ? "#F5EB0D"
                                  : "#7922D8"
                              }
                            >
                              {row.status}
                            </Typography>
                          </TableCell>
                        ) : val === "role_name" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {t("phoneNo")} : {row.contact}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "assigned_pages" ? (
                          <TableCell>
                            <Button
                              startIcon={
                                expandedRow === index ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )
                              }
                              disableRipple
                              variant="none"
                              sx={{ "&:hover": { background: "transparent" } }}
                              onClick={() => handleAccordionToggle(index)}
                            >
                              {expandedRow === index ? t("less") : t("more")}
                            </Button>
                          </TableCell>
                        ) : //clients
                        val === "service_recall" ? (
                          <TableCell>
                            {row.recall > 1
                              ? `${row.recall} times`
                              : `${row.recall} time `}
                          </TableCell>
                        ) : val === "service_sale" ? (
                          <TableCell>{`${row.sale} USD`}</TableCell>
                        ) : val === "appointment_id" ? (
                          <TableCell>{`#${row.refrendId}`}</TableCell>
                        ) : val === "appointment_booked_date" ? (
                          <TableCell>
                            <Box>{formattedDate(row.createdDate, false)}</Box>
                            {formattedTime(row.createdDate, true)}
                          </TableCell>
                        ) : val === "appointment_shedule_date" ? (
                          <TableCell>
                            <Box>{formattedDate(row.sheduleAt, false)}</Box>
                            {formattedTime(row.sheduleAt, true)}
                          </TableCell>
                        ) : val === "appointment_duration" ? (
                          <TableCell>{`${row.duration} min`}</TableCell>
                        ) : val === "appointment_status" ? (
                          <TableCell>
                            <Button
                              variant="none"
                              sx={{
                                height: "35px",
                                fontSize: "0.75rem",
                                color: appcolors.white,
                                boxShadow: "0px 2px 12px 0px #25334226",
                                backgroundColor:
                                  row.status === "Accepted"
                                    ? appcolors.pictonBlue
                                    : row.status === "New"
                                    ? appcolors.tumbleweed
                                    : appcolors.caribbeanGreen,
                                "&:hover": {
                                  backgroundColor:
                                    row.status === "Accepted"
                                      ? appcolors.pictonBlue
                                      : row.status === "New"
                                      ? appcolors.tumbleweed
                                      : appcolors.caribbeanGreen,
                                },
                              }}
                            >
                              {row.status}
                            </Button>
                          </TableCell>
                        ) : val === "client_user_details" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.email}
                                </Typography>

                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.contact}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "change_map" ? (
                          <TableCell>
                            <Box width={25}>
                              <img
                                src={allIcons.mapIcon}
                                alt={"map-icon"}
                                width={"100%"}
                              />
                            </Box>
                          </TableCell>
                        ) : /**
                         * Worker Val
                         * */
                        val === "worker_designation" ? (
                          <TableCell>
                            {`${row.designation.join("\n")}`}
                          </TableCell>
                        ) : val === "worker_details" ? (
                          <TableCell>
                            <Stack
                              gap={1.5}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                sx={{ height: "60px", width: "60px" }}
                              />
                              <Stack>
                                <Typography
                                  variant="h1"
                                  fontSize={"0.875rem"}
                                  fontWeight={600}
                                  color={appcolors.black}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.email}/{row.contact}
                                </Typography>

                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {row.location}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                  color={appcolors.gunmetal}
                                  textTransform={"capitalize"}
                                >
                                  {t("cnic")}:{row.cnic}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : // company catalogue tab
                        val === "company_category" ? (
                          <TableCell>
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                alt={`${row.name}-image`}
                                sx={{
                                  borderRadius: 2,
                                  height: 60,
                                  width: 60,
                                }}
                              />
                              <Stack>
                                <Typography
                                  fontSize={"1.125rem"}
                                  fontWeight={600}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.875rem"}
                                >
                                  {t("totalServices")} :{row.totalService}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "company_service_details" ? (
                          <TableCell>
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                alt={`${row.name}-image`}
                                sx={{
                                  height: 60,
                                  width: 60,
                                }}
                              />
                              <Stack>
                                <Typography
                                  fontSize={"1.125rem"}
                                  fontWeight={600}
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  fontSize={"0.75rem"}
                                >
                                  {t("profitEachOrder")} :{row.profitPercentage}
                                  %
                                </Typography>
                                <Stack
                                  gap={1}
                                  direction={"row"}
                                  alignItems={"center"}
                                >
                                  <Rating
                                    value={4}
                                    precision={0.5}
                                    max={1}
                                    readOnly
                                    size="small"
                                    color="#FF9A01"
                                  />
                                  <Typography variant="body2" color={"#747677"}>
                                    {`${row.rating} (${row.reviews} ${t(
                                      "reviews"
                                    )})`}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "service_working_cost" ? (
                          <TableCell>
                            <Typography>{`${row.cost}USD`}</Typography>
                            <Typography>{row.costWAcc}</Typography>
                          </TableCell>
                        ) : //Eduction Dasboard

                        val === "ed_student_detail" ? (
                          <TableCell>
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              <Avatar
                                src={row.image}
                                alt={`${row.name}-image`}
                                sx={{
                                  height: 70,
                                  width: 70,
                                }}
                              />
                              <Stack>
                                <Typography fontSize={"1rem"} fontWeight={600}>
                                  {row.username}
                                </Typography>
                                <Stack mt={0.4}>
                                  <Typography
                                    variant="body2"
                                    lineHeight={"normal"}
                                  >
                                    {t("guardianName")} :{" "}
                                    {row.guardian.username}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    lineHeight={"normal"}
                                  >
                                    {t("guardianContact")}:{" "}
                                    {row.guardian.contact}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    lineHeight={"normal"}
                                  >
                                    {t("address")} : {row.guardian.address}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "ed_student_class" ? (
                          <TableCell>
                            <Typography variant={"body2"} lineHeight={"normal"}>
                              {t("class")} : {row.class}
                            </Typography>
                            <Typography variant={"body2"} lineHeight={"normal"}>
                              {t("section")}: {row.section}
                            </Typography>

                            {showStudentDetails && (
                              <>
                                <Typography
                                  variant={"body2"}
                                  lineHeight={"normal"}
                                >
                                  {row?.subjects?.length} {t("subjects")}
                                </Typography>
                                <Typography
                                  variant={"body2"}
                                  color={"primary.main"}
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleNavigateToStudentDetails()
                                  }
                                >
                                  {t("seeAllDetails")} ....
                                </Typography>
                              </>
                            )}
                          </TableCell>
                        ) : val === "ed_student_fee" ? (
                          <TableCell>
                            <strong> {row.fees} USD</strong>
                          </TableCell>
                        ) : val === "ed_fess_payment_type" ? (
                          <TableCell>
                            {row.paymentType.map((type, index) => (
                              <Typography variant="body2" key={index}>
                                {type}
                              </Typography>
                            ))}
                          </TableCell>
                        ) : val === "ed_fess_payment_status" ? (
                          <TableCell>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={1}
                            >
                              <Typography variant="body2">
                                {t("paid")}
                              </Typography>
                              <img src={allIcons.conformIcon} width={18} />
                            </Stack>
                          </TableCell>
                        ) : val === "ed_fess_request_status" ? (
                          <TableCell>{renderReqStatusButton(row)}</TableCell>
                        ) : val === "ed_current_fees_status" ? (
                          <TableCell>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={1}
                            >
                              <Typography variant="body2">
                                {t("paid")}
                              </Typography>
                              <img src={allIcons.conformIcon} width={18} />
                            </Stack>
                            <Typography variant="body2">
                              {t("admissionFee")} : 200 USD
                            </Typography>
                            <Typography variant="body2">
                              {t("tutionFee")} : 200 USD month
                            </Typography>
                            {showStudentDetails && (
                              <>
                                <Typography
                                  variant={"body2"}
                                  lineHeight={"normal"}
                                >
                                  {row?.subjects?.length} {t("subjects")}
                                </Typography>
                                <Typography
                                  variant={"body2"}
                                  color={"primary.main"}
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleNavigateToStudentDetails()
                                  }
                                >
                                  {t("seeAllDetails")} ....
                                </Typography>
                              </>
                            )}
                          </TableCell>
                        ) : // classes val

                        val === "ed_class_detail" ? (
                          <TableCell>
                            <Typography fontSize={"1rem"} fontWeight={600}>
                              {row.class}
                            </Typography>
                            <Stack mt={0.4}>
                              {row.sections.map((val) => {
                                return (
                                  <Typography variant="body2">
                                    {t("section")} : {val.section}
                                  </Typography>
                                );
                              })}
                            </Stack>
                          </TableCell>
                        ) : val === "ed_class_fee_structure" ? (
                          <TableCell>
                            <Typography fontSize={"1rem"} fontWeight={600}>
                              {t("admissionFee")} : {row.fees} USD
                            </Typography>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={1}
                            >
                              <Typography variant="body2">
                                {row.paymentType}
                              </Typography>
                              <img src={allIcons.conformIcon} width={18} />
                            </Stack>
                          </TableCell>
                        ) : val === "ed_class_limits" ? (
                          <TableCell>
                            <Typography fontSize={"1rem"} fontWeight={600}>
                              {t("total")} :{" "}
                              {row.sections.reduce((a, c) => a + c.limit, 0)}{" "}
                              USD
                            </Typography>
                            <Stack mt={0.4}>
                              {row.sections.map((val) => {
                                return (
                                  <Typography variant="body2">
                                    {`${t("section")} : ${val.section} (${
                                      val.limit
                                    })`}
                                  </Typography>
                                );
                              })}
                            </Stack>
                          </TableCell>
                        ) : val === "ed_id_card_status" ? (
                          <TableCell>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={1}
                            >
                              <img src={allIcons.conformIcon} width={18} />
                              <Typography variant="body2">
                                {t("issued")}
                              </Typography>
                            </Stack>
                            <Typography variant="body2">
                              <b>Isuue Date</b> :{" "}
                              {moment(new Date()).format("DD-MMM-YYYY hh:mm:a")}
                            </Typography>
                            <Typography variant="body2">
                              <b>Expiry Date</b> :{" "}
                              {moment(new Date()).format("DD-MMM-YYYY hh:mm:a")}
                            </Typography>
                          </TableCell>
                        ) : val === "actions" ? (
                          <TableCell>
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              {showMapIcon && (
                                <Box width={25}>
                                  <img
                                    src={allIcons.mapIcon}
                                    alt={"map-icon"}
                                    width={"100%"}
                                  />
                                </Box>
                              )}
                              {showPrintButton && (
                                <Stack
                                  gap={0.5}
                                  direction={"row"}
                                  alignItems={"center"}
                                  sx={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={allIcons.exportIcon}
                                    alt={"map-icon"}
                                    width={16}
                                  />
                                  <Typography variant="body2">
                                    {t("print")}
                                  </Typography>
                                </Stack>
                              )}

                              {showGenerateReportButton && (
                                <Stack
                                  gap={0.5}
                                  direction={"row"}
                                  alignItems={"center"}
                                  sx={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleGenerateReport(row, index)
                                  }
                                >
                                  <img
                                    src={allIcons.exportIcon}
                                    alt={"map-icon"}
                                    width={16}
                                  />
                                  <Typography
                                    variant="body2"
                                    textTransform={"capitalize"}
                                  >
                                    {t("generateReport")}
                                  </Typography>
                                </Stack>
                              )}

                              {showDetail && (
                                <Tooltip title={t("goToDetails")}>
                                  <Box
                                    onClick={() => handleNavigate(row, index)}
                                    sx={{ cursor: "pointer" }}
                                  >
                                    <IconButton>
                                      <img
                                        src={allIcons.rightArrowIcon}
                                        alt="login-icon"
                                        width={"100%"}
                                        // height={"100%"}
                                      />
                                    </IconButton>
                                    <Typography
                                      variant="body2"
                                      fontSize={"0.75rem"}
                                      color={"#343A40"}
                                    >
                                      {t("details")}
                                    </Typography>
                                  </Box>
                                </Tooltip>
                              )}
                              {showBranchChart && (
                                <Tooltip title={t("goToDetails")}>
                                  <Stack
                                    alignItems={"center"}
                                    onClick={() => handleOpenChartRow(index)}
                                    sx={{ cursor: "pointer" }}
                                  >
                                    {expandedChartRow === index ? (
                                      <img
                                        src={allIcons.arrowDownIcon}
                                        alt="login-icon"
                                        width={10}
                                      />
                                    ) : (
                                      <img
                                        src={allIcons.rightArrowIcon}
                                        alt="login-icon"
                                        width={22}
                                      />
                                    )}
                                    <Typography
                                      variant="body2"
                                      fontSize={"0.75rem"}
                                      color={"#343A40"}
                                    >
                                      {t("details")}
                                    </Typography>
                                  </Stack>
                                </Tooltip>
                              )}
                              {showDownloadBtn && (
                                <Tooltip title={t("downloadInvoice")}>
                                  <Stack
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    onClick={() =>
                                      handleDownloadInvoice(row, index)
                                    }
                                    sx={{ cursor: "pointer" }}
                                  >
                                    <StraightIcon
                                      htmlColor={appcolors.primary}
                                      sx={{ transform: "rotate(180deg)" }}
                                    />
                                    <Typography
                                      variant="body2"
                                      fontSize={"0.75rem"}
                                      color={"#343A40"}
                                    >
                                      {t("download")}
                                    </Typography>
                                  </Stack>
                                </Tooltip>
                              )}
                              {showStatusMenu && (
                                <>
                                  <Button
                                    id="status-menu-button"
                                    disableRipple
                                    aria-controls={
                                      openStatusMenu ? "status-menu" : undefined
                                    }
                                    startIcon={
                                      <MoreVertIcon htmlColor="#000000" />
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={
                                      openStatusMenu ? "true" : undefined
                                    }
                                    sx={{
                                      width: "auto",
                                      padding: "5px",
                                      minWidth: 0,
                                      "& .MuiButton-startIcon": {
                                        mx: 0,
                                      },
                                      "&:hover": {
                                        backgroundColor: "#ffffff",
                                      },
                                    }}
                                    onClick={(e) => {
                                      setRowData({ row, index });
                                      setStatusAnchorE1(e.currentTarget); // Pass the target element here
                                    }}
                                  ></Button>

                                  <Menu
                                    id="status-menu"
                                    anchorEl={statusMenuAnchorE1}
                                    open={openStatusMenu}
                                    onClose={handleCloseStatusMenu}
                                    MenuListProps={{
                                      "aria-labelledby": "status-menu-button",
                                    }}
                                    sx={{
                                      ".MuiMenu-paper": {
                                        boxShadow: "none",
                                        border: "1px solid grey",
                                      },
                                    }}
                                    anchorOrigin={{
                                      vertical: "top",
                                      horizontal: "left",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "right",
                                    }}
                                  >
                                    <MenuItem
                                      sx={{
                                        fontSize: "0.875rem",
                                        color: "custom.softGreen",
                                      }}
                                      onClick={() => {
                                        setStatusAnchorE1(null);
                                        handleClickOnstatusMenu(
                                          rowData,
                                          "Accepted"
                                        );
                                      }}
                                    >
                                      {t("accepted")}
                                    </MenuItem>
                                    <MenuItem
                                      sx={{
                                        fontSize: "0.875rem",
                                        color: "custom.radicalRed",
                                      }}
                                      onClick={() => {
                                        setStatusAnchorE1(null);
                                        handleClickOnstatusMenu(
                                          rowData,
                                          "Reject"
                                        );
                                      }}
                                    >
                                      {t("rejected")}
                                    </MenuItem>
                                    <MenuItem
                                      sx={{
                                        fontSize: "0.875rem",
                                      }}
                                      onClick={() => {
                                        setStatusAnchorE1(null);
                                        handleClickOnstatusMenu(
                                          rowData,
                                          "View Details"
                                        );
                                      }}
                                    >
                                      {t("viewDetails")}
                                    </MenuItem>
                                  </Menu>
                                </>
                              )}
                              {showActions && (
                                <>
                                  <Button
                                    disableRipple
                                    id="addEdit-menu-button"
                                    aria-controls={
                                      openAddEditMenu
                                        ? "addEdit-menu"
                                        : undefined
                                    }
                                    startIcon={
                                      <MoreVertIcon htmlColor="#000000" />
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={
                                      openAddEditMenu ? "true" : undefined
                                    }
                                    sx={{
                                      width: "auto",
                                      padding: "5px",
                                      minWidth: 0,
                                      "& .MuiButton-startIcon": {
                                        mx: 0,
                                      },
                                      "&:hover": {
                                        backgroundColor: "#ffffff",
                                      },
                                    }}
                                    onClick={(e) => {
                                      handleClickAddEditMenu(e);
                                      setRowData({ row, index });
                                    }}
                                  ></Button>
                                  <Menu
                                    // disableScrollLock
                                    id="addEdit-menu"
                                    anchorEl={meunAnchorEl}
                                    open={openAddEditMenu}
                                    onClose={handleCloseAddEditMenu}
                                    MenuListProps={{
                                      "aria-labelledby": "addEdit-menu-button",
                                    }}
                                    sx={{
                                      ".MuiMenu-paper": {
                                        boxShadow: "none",
                                        border: "1px solid grey",
                                      },
                                    }}
                                  >
                                    <Stack
                                      direction={"column"}
                                      alignItems={"center"}
                                      spacing={1}
                                      paddingX={1}
                                    >
                                      {showEdit && (
                                        <img
                                          src={allIcons.editIcon}
                                          alt="delete-icon"
                                          width={20}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            handleEdit(rowData);
                                            handleCloseAddEditMenu();
                                          }}
                                        />
                                      )}
                                      {showDelete && (
                                        <img
                                          src={allIcons.deleteIcon}
                                          alt="delete-icon"
                                          width={20}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            handleDelete(rowData);
                                            handleCloseAddEditMenu();
                                          }}
                                        />
                                      )}
                                      {showView && (
                                        <RemoveRedEyeOutlinedIcon
                                          onClick={() => {
                                            handleViewDetail(rowData);
                                            handleCloseAddEditMenu();
                                          }}
                                          sx={{
                                            color: "primary.main",
                                            cursor: "pointer",
                                          }}
                                        />
                                      )}
                                      {showCalender && (
                                        <Tooltip
                                          title={t("loginAsCalendar", {
                                            name: row.name,
                                          })}
                                        >
                                          <img
                                            src={allIcons.calenderIcon}
                                            alt="calender-icon"
                                            width={20}
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              // handleDelete(row, index);
                                              handleCloseAddEditMenu();
                                            }}
                                          />
                                        </Tooltip>
                                      )}
                                      {showLogin && (
                                        <Tooltip
                                          title={`${t("loginAs")} ${row.name} `}
                                        >
                                          <img
                                            src={allIcons.loginIcon}
                                            alt="login-icon"
                                            width={22}
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              // handleDelete(row, index);
                                              handleCloseAddEditMenu();
                                            }}
                                          />
                                        </Tooltip>
                                      )}
                                    </Stack>
                                  </Menu>
                                </>
                              )}
                            </Stack>
                          </TableCell>
                        ) : (
                          <TableCell>
                            <Typography fontSize={13} lineHeight="normal">
                              {row[val]}
                            </Typography>
                          </TableCell>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={tableHeader.length}
                    style={{ padding: 0, borderBottom: "none" }}
                  >
                    <Collapse
                      in={expandedRow === index}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Paper elevation={2} sx={{ marginBottom: 0, padding: 2 }}>
                        <Typography
                          variant="h1"
                          fontWeight={600}
                          fontSize={"1rem"}
                        >
                          {t("allModules")}
                        </Typography>
                        <List>
                          {SupplierRoutes.map((valll, _ind) => {
                            let assigned = row.assignedPages?.find(
                              (it) => it === valll.name
                            );
                            console.log(assigned, "ASdasjhdashdhasjdjhas");
                            return (
                              <ListItem>
                                <ListItemIcon>
                                  <img
                                    src={
                                      assigned !== undefined
                                        ? allIcons.checkSquareIcon
                                        : allIcons.uncheckSquareIcon
                                    }
                                    alt="check-icon"
                                    width={20}
                                  />
                                </ListItemIcon>
                                <ListItemText secondary={valll.name} />
                              </ListItem>
                            );
                          })}
                        </List>
                      </Paper>
                    </Collapse>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={tableHeader.length}
                    style={{ padding: 0, borderBottom: "none" }}
                  >
                    <Collapse
                      in={expandedChartRow === index}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Paper elevation={2} sx={{ marginBottom: 0, padding: 2 }}>
                        <BarChart yh={"330px"} />
                      </Paper>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
      <TablePagination
        sx={{ display: showPagination ? "block" : "none" }}
        rowsPerPageOptions={[10, 25, 50, 100, { label: t("all"), value: -1 }]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        labelRowsPerPage={t("rowsPerPage")}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}
